module.exports = __webpack_public_path__ + "img/services-shape-1.6a2240f6.png";